import { Component, inject } from "@angular/core";
import { CardModalService } from "@app/shared/card-modal/card-modal.service";
import { TranslateModule } from "@ngx-translate/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

@Component({
    selector: "wk-taxprep-north-panel",
    imports: [TranslateModule, JumpstartComponentsModule],
    templateUrl: "./taxprep-north-panel.component.html",
    styleUrl: "./taxprep-north-panel.component.scss",
    host: { class: "wk-cm__tags" },
})
export class TaxprepNorthPanelComponent {
    public readonly cardModalService = inject(CardModalService);
}
